function findUsedGcmConsentTypes(services) {
    return [
        ...new Set(services.map((param)=>{
            let { googleConsentModeConsentTypes } = param;
            return(// Create copy when it comes as `ObservableArray` (mobx)
            [
                ...googleConsentModeConsentTypes
            ]);
        }).flat())
    ];
}
export { findUsedGcmConsentTypes };
